import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { ComponentsModule } from '@nx-customer-apps/components';
import { SharedUiModule } from '@nx-customer-apps/shared/ui';
import { API_PLANNING_PROJECTS_CONFIG, ApiPlanningProjectsConfig, createRoomByRoomService } from './api-plannig-projects.config';
import { SectionComponent } from './shared';
import {
    CalculationBaseComponent,
    DefaultValuesComponent,
    LevelRoomsPanelComponent,
    RoomEditorComponent,
    RoomListComponent
} from './components';
import { RoomTypePipe, ValueWithUnitPipe } from './pipes';
import { RoomByRoomCalculatorComponent } from './components/room-by-room-calculator/room-by-room-calculator.component';
import { RoomByRoomApiService } from './services';

const COMPONENTS = [
    SectionComponent,
    CalculationBaseComponent,
    DefaultValuesComponent,
    RoomEditorComponent,
    RoomListComponent,
    LevelRoomsPanelComponent,
    RoomByRoomCalculatorComponent
];
const PIPES = [ValueWithUnitPipe, RoomTypePipe];

@NgModule({
    imports: [CommonModule, ReactiveFormsModule, ComponentsModule, SharedUiModule, TranslateModule, ...COMPONENTS, ...PIPES],
    exports: [...COMPONENTS, ...PIPES]
})
export class RoomByRoomModule {
    static forRoot(config: ApiPlanningProjectsConfig): ModuleWithProviders<RoomByRoomModule> {
        return {
            ngModule: RoomByRoomModule,
            providers: [
                {
                    provide: API_PLANNING_PROJECTS_CONFIG,
                    useValue: config
                },
                {
                    provide: RoomByRoomApiService,
                    useFactory: createRoomByRoomService,
                    deps: [API_PLANNING_PROJECTS_CONFIG, HttpClient]
                }
            ]
        };
    }

    constructor(@Optional() @SkipSelf() parentModule: RoomByRoomModule, @Optional() http: HttpClient) {
        if (!http) {
            throw new Error('You need to import the HttpClient in your AppModule!');
        }
    }
}
